module.exports = __webpack_public_path__ + "static/media/ehealth_website_banner_mobile.62c2e70e.jpg";